import { NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomformComponentDef } from '@df/catalog-ui/customform/customform.component.def';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { FileUploadComponent } from '@df/ui/form/file-upload/file-upload.component';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from '../../ui/api/action.component';
import { CheckboxComponent } from '../../ui/form/checkbox';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { RadioComponent } from '../../ui/form/radio';
import { ResultComponent } from '../../ui/resut/result.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

@Component({
    selector: 'customform',
    templateUrl: './customform.component.html',
    styleUrls: ['./customform.component.scss'],
    standalone: true,
    imports: [
        ActionComponent,
        CheckboxComponent,
        FileUploadComponent,
        FormsModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        MuiInputDirective,
        NgIf,
        NgFor,
        NgSwitch,
        NgSwitchCase,
        RadioComponent,
        RadioGroupDirective,
        ResultComponent,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomformComponent extends CustomformComponentDef<{}> {}
